import { useCallback } from 'react';
import type { EntityListType } from '../../../../context/DependencyGraphProvider/types';
import InterfacePageHelper from '../../../../helper/InterfacePage';
import { useAppDataSourceRecordStore } from '../../../../stores/DataSourceRecordStore';
import {
  getActiveInterfacePage,
  useGetAppInterfaceStoreState,
} from '../../../../stores/InterfaceStore/builder';

export function useGetEntityListForApp() {
  const getAppDataSourceRecordStoreState = useAppDataSourceRecordStore().getState;
  const { getAppInterfaceStoreState } = useGetAppInterfaceStoreState();

  const getEntityListForApp = useCallback<() => EntityListType>(() => {
    const dataSourceRecords = getAppDataSourceRecordStoreState().dataSources;
    const activeInterfacePage = getActiveInterfacePage(getAppInterfaceStoreState());
    const pageFunctions = InterfacePageHelper.getPageFunctions(activeInterfacePage);

    const entityList: EntityListType = {
      blocksState: {},
      blocks: {},
      pageFunctions: { ...pageFunctions },
      entityDataSources: {},
      dataSources: { ...dataSourceRecords },
      pageFieldDependencies: activeInterfacePage?.properties.dependencies ?? {},
      documentTitle: '',
    };

    return entityList;
  }, [getAppDataSourceRecordStoreState, getAppInterfaceStoreState]);

  return { getEntityListForApp };
}
